import { render, staticRenderFns } from "./CourseModule.vue?vue&type=template&id=4de313d6&scoped=true&"
import script from "./CourseModule.vue?vue&type=script&lang=js&"
export * from "./CourseModule.vue?vue&type=script&lang=js&"
import style0 from "./CourseModule.vue?vue&type=style&index=0&id=4de313d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de313d6",
  null
  
)

export default component.exports